import { Checkbox, Form } from 'antd';
import { CheckboxProps } from 'antd/lib/checkbox';
import React, { useContext } from 'react';

// import { RuleObject } from 'antd/lib/form';
import Paragraph from 'components/atoms/Paragraph';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

const { Item } = Form;

interface ICheckboxComponent extends CheckboxProps {
    name: string;
    autoFocus?: boolean;
    checked?: boolean;
    defaultChecked?: boolean;
    disabled?: boolean;
    indeterminate?: boolean;
    onChange?: (e: unknown) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    checkboxText: any; // TODO: Zbavit se any
    extramessage?: string;
    notRequired?: boolean;
}

const CheckboxComponent: React.FC<ICheckboxComponent> = props => {
    const {
        name,
        autoFocus,
        checked,
        defaultChecked,
        indeterminate,
        onChange,
        checkboxText,
        extramessage,
        disabled,
        notRequired
    } = props;
    const { language } = useContext(Context);
    return (
        <Item
            name={name}
            extra={extramessage ? <Paragraph text={extramessage} className="extramessage-text" /> : null}
            valuePropName="checked"
            rules={[
                notRequired
                    ? {
                          required: false
                      }
                    : {
                          required: true,
                          transform: value => value || undefined,
                          type: 'boolean',
                          message: (
                              <div className="checkbox-component-rulesmg">
                                  <TranslateText>POTVRDIT_SOUHLAS</TranslateText>
                              </div>
                          )
                      }
            ]}
            key={`${name}${language}`}
        >
            <Checkbox
                disabled={disabled}
                autoFocus={autoFocus}
                checked={checked}
                defaultChecked={defaultChecked}
                indeterminate={indeterminate}
                onChange={onChange}
            >
                <Paragraph text={checkboxText} />
            </Checkbox>
        </Item>
    );
};

export default CheckboxComponent;
